module.exports = __webpack_public_path__ + "img/HD_transparent_picture.d4d6dafe.png";